var _style, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000128449979660745954730000002650667674468081336_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 683.8 1072.5",
    style: {
      enableBackground: "new 0 0 683.8 1072.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.15;fill:#808080;enable-background:new    ;}\n\t.st1{opacity:0.15;}\n\t.st2{fill:#808080;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    className: "st0",
    d: "M1.7,965.3h680.5v107.2H1.7V965.3L1.7,965.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    transform: "translate(1496.083 557.631)",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    className: "st2",
    d: "M-1154.1,92.2c24.8,0,46.9-4.1,66.4-12.3c19-7.8,35.9-19.9,49.4-35.2 c13.5-15.3,23.7-33.9,30.8-56c7.1-22,10.6-47.1,10.7-75.1v-471.3h184.6v471.3c0,48.8-7.9,93.6-23.7,134.4 c-15.8,40.8-38.5,75.9-68,105.4c-29.5,29.5-65.4,52.4-107.6,68.8c-42.3,16.4-89.8,24.6-142.5,24.6c-53.2,0-100.8-8.2-143.1-24.6 c-42.2-16.4-78.1-39.3-107.6-68.8c-29.5-29.5-52.1-64.6-67.7-105.4c-15.7-40.8-23.5-85.5-23.5-134.4v-471.3h184.6v470.8 c0,28,3.6,53.1,10.7,75.1c7.1,22,17.4,40.8,30.9,56.2c13.5,15.5,30.4,27.7,49.4,35.5C-1201,88.1-1178.9,92.2-1154.1,92.2 L-1154.1,92.2z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.8f84fb7013c017e71ac308e9ce94ea34.svg";
export { ForwardRef as ReactComponent };